//patchwork-hover


'use strict';

(function() {

    $('.patchwork-hover--slot').mouseenter(function(){
        var $artID = $(this).parents('.__js_stats_wrapper').data('id'),
            $galID = $(this).parents('.patchwork-hover--wrapper').data('gallery'),
            $imgID = $(this).find('.patchwork-hover--slot-img').attr('src');

        //console.log('art:' + $artID + 'gal:' + $galID + ' / img: ' + $imgID);

        sendStats('gallery', 'hover', $artID + ' / ' + $galID, $imgID);
    });

})();


//patchwork
$.fn.zoomer = function() {
  return this.each(function() {
    var $this = $(this),
      $lista = $this.find(">*"),
      count = $lista.length,
      $arId = $(this)
        .parents("article")
        .data("id"),
      $gId = $(this)
        .parents(".patchwork--deco")
        .data("gallery"),
      $acId,
      $slotId,
      open = function(n) {
        if ($(".patchwork--lightbox").length) {
          goTo(n);
        } else {
          var tmp = document.querySelector("template.lightbox"),
            cln = tmp.content.cloneNode(true),
            $lb = $('<div class="patchwork--lightbox">')
              .append(cln)
              .appendTo("body");
          $lb.find(".patchwork--close").bind("click", function() {
            $(".patchwork--deco.__js_active").removeClass("__js_active");
            $("body")
              .find("div.patchwork--lightbox")
              .remove();
          });
          var $next = $lb.find(".patchwork--next"),
            $prev = $lb.find(".patchwork--prev"),
            $foto = $lb.find(".patchwork--big"),
            $text = $lb.find(".patchwork--desc"),
            active = n,
            goTo = function(n) {
              active = n;

              //console.log($lista.eq(n).data('big'), $lista.eq(n).find('.patchwork--desc').html());

              $foto.attr("src", $lista.eq(n).data("big"));
              $text.html(
                $lista
                  .eq(n)
                  .find(".patchwork--desc")
                  .html()
              );

              $acId = $lista.eq(n).data("big");
              $slotId = $lista.eq(n).data("order");
              $gId = $(".patchwork--deco.__js_active").data("gallery");
              
              sendStats(
                "gallery",
                "click-big-" + $slotId,
                $arId + " / " + $gId
              );
            },
            goNext = function() {
              active++;
              if (active > count - 1) active = 0;
              goTo(active);
            },
            goPrev = function() {
              active--;
              if (active < 0) active = count - 1;
              goTo(active);
            };
          $next
            .bind("mousedown", function(e) {
              e.preventDefault();
            })
            .bind("click", goNext);
          $prev
            .bind("mousedown", function(e) {
              e.preventDefault();
            })
            .bind("click", goPrev);
          goTo(active);
        }
      };
    //init asdasd
    $this.find(".patchwork--slot").bind("click", function() {
        
      $(this)
        .parents(".patchwork--deco")
        .addClass("__js_active");

      var $arId = $(this)
          .parents("article")
          .data("id"),
        $gId = $(this)
          .parents(".patchwork--deco")
          .data("gallery"),
        $acId = $(this)
          .parent()
          .find(".patchwork--slot-img")
          .attr("src"),
        $slotId = $(this).data("order");

      sendStats("gallery", "click-small-" + $slotId, $arId + " / " + $gId);

      open($(this).index());
    });
  });
};

$(".patchwork").zoomer();
